import CircularLoader from "@/components/loading/LoadingComponent";
import { AuthContext } from "@/contexts/AuthContext";
import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

interface GuardProps {
    children: React.ReactNode;
}

const ShieldGuard = ({ children }: GuardProps) => {
    const { user, loading } = useContext(AuthContext);
    const navigate = useNavigate();

    useEffect(() => {
        // Check if the user.player.shield exists, otherwise navigate to /forge
        // If user.play doesn't exist then navihate to /subscribe
        if (!loading && user) {
            if (!user.player) {
                navigate("/subscribe");
            } else if (!user.player.shield) {
                navigate("/forge");
            }
        }
    }, [user, loading, navigate]);

    if (loading) {
        return <CircularLoader />;
    }

    return <>{children}</>;
};

export default ShieldGuard;
